import { SearchResultActions, SearchResultActionTypes } from '../actions/search-result.actions';
import { Result } from '../search/SearchResult.interface';


export const searchResultFeatureKey = 'searchResultKey';

export interface SearchResultState {
  resultCount: number;
  searchTerm: string;
  lastSearchterm: String;
  didYouMean: string;
  monographs: Result[];
  conditions: Result[];
  patientInfo: Result[];
  npd: Result[];
  monographCount: number;
  conditionsCount: number;
  patientinfoCount: number;
  npdCount: number;
  groupMaxResultCounts: any;
  subcounts: Map<string, number>;
  mostRelevantResult: any;
  fullResults: Result[];
}

export const initialState: SearchResultState = {
  resultCount: 0,
  searchTerm: "",
  lastSearchterm: "",
  didYouMean: "",
  monographs: [],
  conditions: [],
  patientInfo: [],
  npd: [],
  monographCount: 0,
  conditionsCount: 0,
  patientinfoCount: 0,
  groupMaxResultCounts: {},
  npdCount: 0,
  subcounts: new Map(),
  mostRelevantResult: {},
  fullResults: []
};

export function searchResultReducer(state = initialState, action: SearchResultActions): SearchResultState {
  switch (action.type) {
    case SearchResultActionTypes.LoadSearchResults:
      return { ...state, resultCount: action.resultCount, searchTerm: action.searchTerm,lastSearchterm: action.searchTerm, didYouMean: action.didYouMean,
                         monographs: action.monographs, conditions: action.conditions, patientInfo: action.patientInfo,
                         monographCount: action.monographCount, conditionsCount: action.conditionsCount,
                         patientinfoCount: action.patientinfoCount, npd : action.npd, npdCount: action.npdCount,
        mostRelevantResult: action.mostRelevantResult, fullResults: action.fullResults, subcounts: action.subcounts};
    case SearchResultActionTypes.RemoveSearchResults:
      return { ...state, resultCount: 0, searchTerm: "", fullResults: [], monographs: [], conditions: [], patientInfo: [],
                         monographCount: 0, conditionsCount: 0, patientinfoCount: 0 };
    case SearchResultActionTypes.DoSearch:
      return state;
    case SearchResultActionTypes.DoMoreSearch:
      return state;
    case SearchResultActionTypes.addMoreResults:
      if (!!action.groupId && action.groupId !== '') {
        state.groupMaxResultCounts[action.groupId] = action.maxResults;
      }
      if(action.results.length > 0) {
        return {...state, fullResults: [...state.fullResults, ...action.results]};
      }
      return {...state};
    case SearchResultActionTypes.addLessResults:
      if(action.monographs.length > 0) {
              state.fullResults = state.fullResults.filter(d => d.type !== 'MONOGRAPH');
              state.fullResults = state.fullResults.filter(d => d.type !== 'CLININFO');
              return {...state, fullResults: [...state.fullResults, ...action.monographs]};
      } else if(action.conditions.length > 0) {
              state.fullResults = state.fullResults.filter(d => d.type !== 'CHAPTER');
              state.fullResults = state.fullResults.filter(d => d.type !== 'PMA');
              state.fullResults = state.fullResults.filter(d => d.type !== 'MA_CHAPTER');
              return {...state, fullResults: [...state.fullResults, ...action.conditions]};
      } else if(action.patientInfo.length > 0) {
              state.fullResults = state.fullResults.filter(d => d.type !== 'IFP');
              state.fullResults = state.fullResults.filter(d => d.type !== 'MA_PI');
              return {...state, fullResults: [...state.fullResults, ...action.patientInfo]};
      }
      break;
    case SearchResultActionTypes.setMaxCountForGroup:
      state.groupMaxResultCounts[action.groupId] = action.maxResults;
      return {...state};
    case SearchResultActionTypes.clearMaxResultCountMap:
      state.groupMaxResultCounts = {};
      return {...state};
    default:
      return state;
  }
}

export function reducer(state: SearchResultState, action: SearchResultActions): SearchResultState {
  return searchResultReducer(state, action);
}
